module.exports = __webpack_public_path__ + "static/404-72ad03eec7d9cdd2a68b0ce178541aa1.png";